(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["electronic-badge-accordion-card"] && !Shopify.designMode) return;
  try {
    class ElectronicBadgeAccordionCard extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.details = this.querySelector('details');
      this.onToggle = this.handleToggle.bind(this);
      this.details?.addEventListener('toggle', this.onToggle);
    }

    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.onToggle);
      this.isInitialized = false;
    }

    handleToggle() {
      if (!this.details?.open) return;

      if (!this.hasAttribute('data-contains-app')) return;

      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
        window.setTimeout(() => window.dispatchEvent(new Event('resize')), 260);
      });
    }
  }

  if (!customElements.get('electronic-badge-accordion-card')) {
    customElements.define('electronic-badge-accordion-card', ElectronicBadgeAccordionCard);
  }
  } catch(e) { console.error(e); }
})();

})();
